import { createAction, props } from '@ngrx/store';

import { ScrollEventInterface } from './scroll.models';

export const scroll = createAction('[Tracking][BAU365] Scroll', props<ScrollEventInterface>());
